import { MuiDatePicker, MuiDateTimePicker, MuiKeyboardDatePicker, MuiTimePicker } from '@gef-ui/components/atoms/MuiPickers';
import chainHandlers from "@gef-ui/utils/chainHandlers";
import React from 'react';
import { fieldTypes, inputColor, validationColor } from '../../../../constants';
const variant = {
    [fieldTypes.DATE_PICKER_MUI]: MuiDatePicker,
    [fieldTypes.KEYBOARD_DATE_PICKER_MUI]: MuiKeyboardDatePicker,
    [fieldTypes.DATE_TIME_PICKER_MUI]: MuiDateTimePicker,
    [fieldTypes.TIME_PICKER_MUI]: MuiTimePicker
};
export default ((fieldType)=>({ codelistName, optionsFilter, handleFocusFalse, handleFocusTrue, options, viewParser, focus, errMeta, handleChange, formName, handleUpdate, handleAsyncValidate, value, displayValue, handleValidate, valid, label, errMessage, disabled, onChange, onBlur, fieldName, ...other })=>{
        const Picker = variant[fieldType];
        displayValue = value ? undefined : '';
        return /*#__PURE__*/ React.createElement(Picker, {
            id: fieldName,
            floatingLabelText: label,
            validationText: errMessage,
            controlClassName: inputColor(valid),
            disabled: disabled,
            validationClassName: validationColor(valid),
            onClickPanelClear: handleValidate,
            value: value,
            displayValue: displayValue,
            onAccept: chainHandlers([
                handleUpdate,
                handleAsyncValidate,
                handleValidate,
                onChange
            ]),
            onChange: (date)=>chainHandlers([
                    handleUpdate,
                    onChange
                ])(null, date || ''),
            onBlur: chainHandlers([
                handleAsyncValidate,
                handleValidate,
                onBlur
            ]),
            ...other
        });
    });
